/**
 * Certifications.
 */

// Module styles
import './_certifications.scss';
